import createAxiosInstance from '../../../api';
import { useAlert } from '../../../components/Notification';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  setManufaturedInventoryListAction,
  setUnregisteredInventoryListAction,
  setRegisteredInventoryListAction,
  setInventoryFilterAction,
} from '../../../stores/actionTypes/inventoryActions';

export function useHook() {
  const axiosInstance = createAxiosInstance();
  const navigate = useNavigate();
  const showAlert = useAlert();
  const dispatch = useDispatch();

  const fetchManufacturedInventory = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/manufacturedInventory', payload)
      .then((response) => {
        dispatch(setManufaturedInventoryListAction(response?.data?.data));
        data = response.data;
      })
      .catch(() => {
        dispatch(setManufaturedInventoryListAction([]));
        showAlert('Failed get List ManufacturedInventory', 'warning');
      });
    return data;
  };

  const fetchRisteredInventory = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/registeredInventory', payload)
      .then((response) => {
        dispatch(setRegisteredInventoryListAction(response?.data?.data));
        data = response.data;
      })
      .catch(() => {
        dispatch(setRegisteredInventoryListAction([]));
        showAlert('Failed get List RegisteredInventory', 'warning');
      });
    return data;
  };

  const fetchUnRisteredInventory = async (payload) => {
    let data = null;
    await axiosInstance
      .post('/unregisteredInventory', payload)
      .then((response) => {
        dispatch(setUnregisteredInventoryListAction(response?.data?.data));
        data = response.data;
      })
      .catch(() => {
        dispatch(setUnregisteredInventoryListAction([]));
        showAlert('Failed get List UnregisteredInventoryList', 'warning');
      });
    return data;
  };

  const assignInventory = async (payload) => {
    await axiosInstance
      .post('/assignInventory', payload)
      .then(() => {
        showAlert('Assign Update successfully', 'success');
      })
      .catch(() => {
        showAlert('Failed to Assign Update', 'warning');
      });
  };

  const readyToDispatch = async (payload) => {
    await axiosInstance
      .post('/readyToDispatch', payload)
      .then(() => {
        showAlert('Dispatch successfully', 'success');
      })
      .catch(() => {
        showAlert('Failed to Dispatch', 'warning');
      });
  };

  const fetchGetInventoryFilter = async () => {
    await axiosInstance
      .get('/inventoryFilters')
      .then((response) => {
        dispatch(setInventoryFilterAction(response?.data?.data));
      })
      .catch(() => {
        dispatch(setInventoryFilterAction([]));
        showAlert('Failed get  Inventory Filter', 'warning');
      });
  };

  return {
    fetchManufacturedInventory,
    fetchRisteredInventory,
    fetchUnRisteredInventory,
    assignInventory,
    readyToDispatch,
    fetchGetInventoryFilter,
  };
}
